import Loader from "./Loader";

export default function LoadingSection({ isFixed }) {
    return (
        <div className={`${isFixed ? 'fixed inset-0' : 'w-full h-screen'} bg-slate-500/60 flex justify-center items-center opacity-100`}>
            <Loader />
        </div>
    )
}